
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.99991 1.33331C7.12443 1.33331 6.25752 1.50575 5.44869 1.84078C4.63985 2.17581 3.90492 2.66688 3.28587 3.28593C2.03562 4.53618 1.33324 6.23187 1.33324 7.99998C1.32742 9.5394 1.86044 11.0323 2.83991 12.22L1.50658 13.5533C1.41407 13.6471 1.35141 13.7661 1.32649 13.8954C1.30158 14.0248 1.31552 14.1586 1.36658 14.28C1.42195 14.3999 1.51171 14.5007 1.62448 14.5696C1.73724 14.6384 1.86791 14.6722 1.99991 14.6666H7.99991C9.76802 14.6666 11.4637 13.9643 12.714 12.714C13.9642 11.4638 14.6666 9.76809 14.6666 7.99998C14.6666 6.23187 13.9642 4.53618 12.714 3.28593C11.4637 2.03569 9.76802 1.33331 7.99991 1.33331ZM7.99991 13.3333H3.60658L4.22658 12.7133C4.35074 12.5884 4.42044 12.4194 4.42044 12.2433C4.42044 12.0672 4.35074 11.8982 4.22658 11.7733C3.35363 10.9013 2.81003 9.75367 2.68837 8.52584C2.56672 7.29801 2.87454 6.06598 3.5594 5.03966C4.24425 4.01334 5.26377 3.25622 6.44425 2.89729C7.62474 2.53837 8.89315 2.59985 10.0334 3.07126C11.1736 3.54266 12.1151 4.39483 12.6975 5.48257C13.2799 6.57032 13.4672 7.82634 13.2273 9.03665C12.9875 10.247 12.3354 11.3367 11.3823 12.1201C10.4291 12.9036 9.23375 13.3323 7.99991 13.3333Z","fill":"currentColor"}})])
          )
        }
      }
    